import { useAtom } from 'jotai';
import { withImmer } from 'jotai-immer';
import { atomWithStorage } from 'jotai/utils';

type AuthLocalStoredState = {
    beforeLoginPath: string | undefined;
}
const authLocalStoredStateAtom = withImmer(atomWithStorage<AuthLocalStoredState>('store', {
    beforeLoginPath: void 0,
}));
export const useAuthLocalStoredState = () => useAtom(authLocalStoredStateAtom);
